export default {
  LICENSE_NO_REPEAT_EMAIL: 'Added mailboxes cannot be duplicated',
  LICENSE_NO_NOTICED_EMAIL: 'No notification mailbox',
  LICENSE_FIXED_DESK: 'Fixed Desk（{val}）',
  LICENSE_HOT_DESK: 'Hot Desk（{val}）',
  LICENSE_EMAIL_NO_MORE_TEN: 'The number of mailboxes to receive notifications cannot exceed 10.',
  LICENSE_AUTHORIZED: 'Authorized',
  LICENSE_NOT_AUTHORIZED: 'Unauthorized'
}
